
import React, { useEffect, useRef, useState } from "react";
// Import Swiper React components
function Packages() {
  

  return (
    <div className="App">
 


             

 {/* <!-- Page banner Section Start --> */}
        <div class="section page-banner-section about-back-img">
            <div class="container">

                {/* <!-- Page banner Section Start --> */}
                <div class="page-banner-content">
                    <h2 class="page-title">Our Packages</h2>

                    <ul class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item active">Packages</li>
                    </ul>
                </div>
                {/* <!-- Page banner Section End --> */}

            </div>
        </div>
        {/* <!-- Page banner Section End --> */}

     
       {/* <!-- Our Mission & Vission Section Start --> */}
       <div class="section section-padding" style={{paddingTop : 80, paddingBottom : 40}}>
            <div class="container">
        {/* <!-- Section Title Start --> */}
        <div class="section-title">
                    <h6 class="sub-title">Consultation Options</h6>
                    <h2 class="main-title">Flexible options for your ease</h2>
                </div>
                {/* <!-- Section Title End --> */}
                </div>
                </div>

<div className="row" style={{justifyContent : 'center', marginBottom : 100}}>
        {/* <!-- Our Mission & Vission Section Start --> */}
        <div class="col-lg-4">
            <div class="container">

                {/* <!-- Our Mission Wrapper Start --> */}
                <div class="single-student-widget widget-color-01">
                                    <h4 class="widget-title" style={{paddingTop : 20}}>BASIC PACKAGE
                                        {/* <p style={{fontSize : '14px'}}>One Month</p> */}
                                            </h4>
                                        

                                        <div class="widget-items">

                                        <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag row">
                                                    {/* <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> </div> */}
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Ideal for:</strong> Beginners or those looking for general health support </div>
                                                
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item Start --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Weekly meal plans customized by Healthfitsquare's Senior Dietitian Team </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Focused on weight, health, or disease management</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                              {/* <!-- Single Item Start --> */}
                                              <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Weekly audio consultation</strong> with our dietitian team</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Support hours:</strong> Monday-Saturday, 10:00 am to 07:00 pm IST</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Lifestyle guidance: portion control, healthy eating habits, and maintenance</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Regular follow-up with flexible diet plans</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    {/* <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Regular follow up with flexible Diet Plan</div> */}
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                            <h4 class="widget-title" style={{marginTop : 30, background: '#0a4d3c', color: '#fff'}}>Contact Now</h4>

                                        </div>

                                       
                                    </div>
                {/* <!-- Our Mission Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Our Mission & Vission Section End --> */}

        {/* <!-- Our Mission & Vission Section Start --> */}
        <div class="col-lg-4">
            <div class="container">

                {/* <!-- Our Mission Wrapper Start --> */}
                <div class="single-student-widget widget-color-03">
                                        <h4 class="widget-title" style={{paddingTop : 20}}>EXCLUSIVE PACKAGE
                                        {/* <p style={{fontSize : '14px'}}>One Month</p> */}
                                            </h4>
                                        

                                        <div class="widget-items">

                                            {/* <!-- Single Item Start --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Ideal for:</strong> Those looking for deeper guidance and more personalized care </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Customized meal plans by <strong>senior dietitians under Neha Yaduvanshi’s guidance</strong></div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                              {/* <!-- Single Item Start --> */}
                                              <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span>Tailored plans for weight loss, disease-specific needs, or health goals</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Weekly audio consultation</strong> with our dietitian team</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Lifestyle Guidance, guides for Portion control, eating out and Maintenance</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Support hours:</strong> Monday-Saturday, 10:00 am to 07:00 pm IST</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Lifestyle and habit correction: eating out tips, portion control, meal timing</div>
                                                </div>
                                               
                                            </div>

                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Continuous follow-ups and dynamic diet modifications</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                            <h4 class="widget-title" style={{marginTop : 30, background: '#0a4d3c', color: '#fff'}}>Contact Now</h4>

                                        </div>

                                       
                                    </div>
                {/* <!-- Our Mission Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Our Mission & Vission Section End --> */}

        <div class="col-lg-4">
            <div class="container">

                {/* <!-- Our Mission Wrapper Start --> */}
                <div class="single-student-widget widget-color-02">
                                        <h4 class="widget-title" style={{paddingTop : 20}}>PERSONALISED PACKAGE<br/><h6>One-on-One with Dt. Neha Yaduvanshi</h6>
                                        {/* <p style={{fontSize : '14px'}}>One Month</p> */}
                                            </h4>
                                        

                                        <div class="widget-items">

                                            {/* <!-- Single Item Start --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Ideal for:</strong> Those needing premium, highly personalized care </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

 {/* <!-- Single Item Start --> */}
 <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Personally designed meal plans by <strong>Dt. Neha Yaduvanshi</strong></div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Holistic management for weight, chronic health issues, or recovery </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Weekly video consultations</strong> directly with Dt. Neha Yaduvanshi </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                              {/* <!-- Single Item Start --> */}
                                              <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Priority support</strong> from Monday–Saturday, 10:00 AM – 7:00 PM IST</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> In-depth lifestyle coaching: advanced portion guidance, eating out, maintenance strategies</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Frequent follow-ups with highly adaptive diet planning</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    {/* <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Regular follow up with flexible Diet Plan</div> */}
                                                </div>
                                               
                                            </div>
                                           
                                            {/* <!-- Single Item End --> */}

                                            <h4 class="widget-title" style={{marginTop : 15, background: '#0a4d3c', color: '#fff'}}>Contact Now</h4>

                                        </div>

                                       
                                    </div>
                {/* <!-- Our Mission Wrapper End --> */}

            </div>
        </div>
        </div>



    

        {/* <!-- Download App Start --> */}
        <div class="section section-padding download-section" style={{paddingTop : 80, paddingBottom : 80}}>

            <img class="shape-01" src="assets/images/shape/shape-7.png" alt="Shape" />
            <img class="shape-02" src="assets/images/shape/shape-8.png" alt="Shape" />

            <div class="container">

                {/* <!-- Download App Wrapper Start --> */}
                <div class="download-app-wrapper" >

                    {/* <!-- Section Title Start --> */}
                    <div class="section-title shape-none">
                        <h6 class="sub-title">Our Payment Process</h6>
                        <h4 class="main-title" style={{fontSize: '20px'}}>You can scan the QR code here, and send us a screenshot once you make the payment via DM on Whatsapp- <a style={{color : '#fff'}} href="https://wa.me/918447009334">+91-8447009334</a>.<br/><br/>

                        If you require Bank details, please DM us on WhatsApp and we will send it across.

Kindly share the payment confirmation once you do the payment.</h4>

<br/>
<h4  class="main-title" style={{fontSize : 20}}>Google pay,
Phone pay,
Paytm, <br/>
No. - 8447009334</h4>
                    </div>
                    {/* <!-- Section Title End --> */}

                    {/* <!-- Download App Button End --> */}
                    <div class="download-app-btn" >
                        <ul class="app-btn" >
                            <li ><a style={{width : 200, height : 200}}>
                                <img src="assets/images/payment-qr.jpeg"/>
                                </a></li>
                        </ul>
                    </div>
                    {/* <!-- Download App Button End --> */}

                </div>
                {/* <!-- Download App Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Download App End --> */}


        

    </div>
  );
}

export default Packages;
